import { useParams } from 'react-router-dom';
import { TeacherCourseDetailView } from '@/views/TeacherCourseDetailView';
import { MainLayout } from '@/widgets/layouts/MainLayout';

const TeacherCourseDetailPage = () => {
  const { courseId } = useParams<{ courseId: string }>();

  if (!courseId) {
    return null;
  }

  return (
    <MainLayout meta={{ title: 'Course details' }} headerTitle="Course Detail">
      <TeacherCourseDetailView courseId={Number(courseId)} />
    </MainLayout>
  );
};

export default TeacherCourseDetailPage;

